import * as React from "react";
const SvgBranchArm = ({
  title,
  titleId,
  ...props
}) => <svg viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path id="Branch Arm" d="M13.7148 1.0166L9.71256 1.02134C5.30916 1.02656 1.73786 4.58932 1.72209 8.99269L1.71484 11.0166" stroke="#D4E0ED" strokeWidth={2} strokeLinecap="round" /></svg>;
export default SvgBranchArm;